import { useDispatch, useSelector } from 'react-redux';
import { BookingConfirmation, BookingConfirmationSkeleton } from '@components';

import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { getActivityBooking, setRebookingError } from '@share/store/slices';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { NoResults } from '@assets';
import { Routes } from '@share/constants';
import { GetHomeParams, AppDispatch, RootState } from '@share/utils';
import './styles.scss';

export const ActivityConfirmationPage = () => {
    const { id, ratekey, accountUsername } = useParams<{ id: string; ratekey: string; accountUsername?: string }>();

    const { bookingResult, loading, error } = useSelector((state: RootState) => state.activityCheckoutStore);
    const account = useSelector((state: RootState) => state.loginStore?.account);

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (id && ratekey) {
            dispatch(getActivityBooking({ rateKey: ratekey, activityCode: id }));
        } else {
            dispatch(setRebookingError('ERROR'));
        }
    }, [id, ratekey, dispatch]);

    if (loading) {
        return (
            <div className="container py-5">
                <BookingConfirmationSkeleton />
            </div>
        );
    }

    if (bookingResult) {
        return (
            <div className="activityConfirmation">
                <BookingConfirmation bookingData={bookingResult} activityCode={id} />
            </div>
        );
    }

    if (error) {
        const searchPath = `${accountUsername ? `/${accountUsername}${Routes.ActivitiesSearch}` : Routes.ActivitiesSearch}${GetHomeParams(account)}`;
        return (
            <div className="confirmation-error">
                <div className="confirmation-error__card">
                    <div className="confirmation-error__image-wrap">
                        <NoResults />
                    </div>
                    <h1 className="confirmation-error__title">
                        <FormattedMessage id="booking.confirmation.reservation_not_available_title" defaultMessage="Reservation not found" />
                    </h1>
                    <p className="confirmation-error__message">
                        <FormattedMessage id="booking.confirmation.reservation_not_available" defaultMessage="The reservation you're looking for is not available. It may have expired or the link is incorrect." />
                    </p>
                    <div className="confirmation-error__actions">
                        <Link to={searchPath}>
                            <Button type="primary" size="large" className="confirmation-error__btn confirmation-error__btn--primary">
                                <FormattedMessage id="booking.confirmation.back_to_search" defaultMessage="Back to search" />
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};
